import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

export const useHotlinePopupGtmTracking = (regionName: string) => {
    const shareData = {
        event: "widget_find_for_you",
        event_category: regionName
    };

    const hitView = () => {
        const data = {
            ...shareData,
            event_action: "view"
        };

        hitGoogleTagManager(data);
    };

    const hitButtonClick = (buttonLabel: string) => {
        const data = {
            ...shareData,
            event_action: "click",
            event_label: buttonLabel
        };

        hitGoogleTagManager(data);
    };

    return {
        hitView,
        hitButtonClick
    };
};
import {hitGoogleTagManager} from "@pg-mono/google-tag-manager";

export const useHotlinePopupGtmTracking = (regionName: string) => {
    const shareData = {
        event: "widget_find_for_you",
        event_category: regionName
    };

    const hitView = () => {
        const data = {
            ...shareData,
            event_action: "view"
        };

        hitGoogleTagManager(data);
    };

    const hitButtonClick = (buttonLabel: string) => {
        const data = {
            ...shareData,
            event_action: "click",
            event_label: buttonLabel
        };

        hitGoogleTagManager(data);
    };

    return {
        hitView,
        hitButtonClick
    };
};
